'use strict';

import Vue from 'vue';
import VueMask from 'v-mask';
import Event from './event';
import Config from '../config';
import Module from '../modules/';
import components from '../modules/components';
import CartActionRequired from "../modules/cart-action-required";

export default class {

    constructor() {
        this.token = document.head.querySelector('meta[name="csrf-token"]').content;
        this.event = new Event();
        this.config = Config;
        this.countries = [];
        this.user = [];

        Vue.use(VueMask);
        
        this.slick = new Module.Slick();
        this.header = new Module.Header();
        this.magnificPopup = new Module.MagnificPopup();

        new Module.AddToCart();
        new Module.CartSmall();
        new Module.CartNumItems();
        new Module.CartActionRequired();
        new Module.CartTotal();
        new Module.Checkout();
        new Module.PasswordChange();

        new Module.ContactForm();
        new Module.OrderPagination();
    }

    init(url) {
        this.url = url.replace(/\/+$/, "");

        // - Trigger cookie consent banner.
        cookieconsent.initialise(Config.cookieconsent);
        this.slick.init();
        this.header.init();
        this.magnificPopup.init();

        this.fetchUser().then(() =>{
            this.vue = new Vue({
                el: '#app',
                components
            });
            this.cartData();
            $('.popup-gallery').magnificPopup({
                delegate: 'a',
                type: 'image',
                tLoading: 'Loading image #%curr%...',
                mainClass: 'mfp-img-mobile',
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                },
                image: {
                    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                    titleSrc: function(item) {
                        return item.el.attr('title');
                    }
                }
            });
            if ($('#order-form').length > 0) {
                $('#order-form').submit(function(e)
                {  
                    e.preventDefault();
                    $('.order-button').prop('disabled',true);
                    this.submit();
                }); 
              }
        })

        

        
        this.fetchCountries();
        //this.compareData();

        this.checkPopUp();
    }

    cartData() {
        new Form().get('/api/cart/content')
            .then((response) => {
                this.event.fire('cart.data.loaded', response);
            });
    }

    compareData() {
        new Form().get('/api/compare/content')
            .then((response) => {
                this.event.fire('compare.data.loaded', response);
            });
    }

    fetchCountries() {
        new Form().get('/register/countries')
            .then(countries => {
                this.countries = countries;
                this.event.fire('countries.loaded', countries);
            });
    }

    fetchUser() {
        return new Form().get('/api/me')
                .then(user => this.user = user );
    }

    checkPopUp() {
        new Form().get('/api/checkOpenOrders')
            .then((response) => {
                if(response) {
                    swal({ 
                        html:true, 
                        title:'Unbestätigte Bestellung', 
                        text: "Sie haben unbestätigte Bestellungen in Ihrem Benutzerprofil. Bitte bestätigen oder verwerfen Sie die Bestellungen so schnell wie möglich.",
                        type: "warning"
                    });
                }
            });
    }
}